import { AiOutlineClose } from "react-icons/ai";
import { ImageSetBet } from "../ImageSetBet";
import styles from "./styles.module.scss";

export const ModalEvent: React.FC<any> = ({ close, event }: any) => {
	return (
		<div className={styles.modalEvent} onClick={() => close(false)}>
			<div className={styles.container} onClick={(e) => e.stopPropagation()}>
				<AiOutlineClose
					onClick={() => close(false)}
					className={styles.closeModalSvg}
				/>

				<div className={styles.content}>
					<div className={styles.imageContainer}>
						<ImageSetBet src={event?.contentImage?._url} alt="bannerImage" />
					</div>

					<h1>{event?.title}</h1>

					<div
						className={styles.details}
						// biome-ignore lint/security/noDangerouslySetInnerHtml: <explanation>
						dangerouslySetInnerHTML={{ __html: event?.content }}
					/>
				</div>
			</div>
		</div>
	);
};
